export const TRANSPARENT_PNG =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAALSURBVAgdY2BgAAAAAwABT0gKrwAAAABJRU5ErkJggg=='

export default TRANSPARENT_PNG
